<script>
import baseInput from './baseInput'
export default {

    mixins: [ baseInput ],

    name: 'switcher',

    props: {
        id: String,
        label: String,
        labelClasses:String,
        labelInline: Boolean,
        checked: Boolean,
    },

}
</script>

<template lang="html">
    <div class="">
        <label class="switch mb-0">
            <input
            v-if="checked"
            type="checkbox"
            v-model="internalValue"
            :disabled="disabled"
            :readonly="readonly"
            checked
            :required="required"
            >

            <input
            v-else
            type="checkbox"
            v-model="internalValue"
            :disabled="disabled"
            :readonly="readonly"
            :required="required"
            >

            <span class="slider round"></span>
        </label>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/switcher.vue